;(function() {
  'use strict'

  Controller.$inject = ["mediaView"];
  angular.module('app.survey').component('surveyQuestionScore', {
    controller: Controller,
    templateUrl: 'survey-question-score.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(mediaView) {
    var ctrl = this
    var NUMBER_REGEX = /^\s*\d+\s*$/

    ctrl.$onInit = onInit

    ctrl.getCircularChoicesWidth = getCircularChoicesWidth
    ctrl.getCircularChoiceWidth = getCircularChoiceWidth
    ctrl.expandImage = expandImage

    function onInit() {
      ctrl.visibleChoices = ctrl.question.getVisibleChoices()

      // score supports one independent choice shown outside the main options
      var independent = _.remove(ctrl.visibleChoices, function(choice) {
        return choice.data.isIndependent
      })
      ctrl.independent = independent[0]

      if (ctrl.question.matrixEnabled) {
        ctrl.visibleStatements = ctrl.question.getVisibleStatements()
      }

      // Score question can be displayed in 2 types :
      // - Circular: when choices are numeric and in range eg 1 ... 10
      // - Slider: when choices are not numeric or not in range
      var isCircularType = _.every(ctrl.visibleChoices, function(choice, idx) {
        // choice option must be numeric
        if (!NUMBER_REGEX.test(choice.option)) return false

        // first item has nothing to compare to so it's valid
        if (idx === 0) return true

        var prevChoice = ctrl.visibleChoices[idx - 1].option
        var prevNumber = +prevChoice // coerce to number
        var currentNumber = +choice.option // coerce to number
        return currentNumber > prevNumber
      })
      ctrl.displayType = isCircularType ? 'circular' : 'slider'
    }

    function isMobile() {
      return document.body.offsetWidth < 541
    }

    function getPaddingSize() {
      return isMobile() ? 12 : 20
    }

    function getOptionWidth() {
      var bodyWidth = document.body.offsetWidth
      var parentPadding = 16 * 2
      var contentMaxWidth = 600
      var contentWidth =
        bodyWidth > contentMaxWidth + parentPadding
          ? contentMaxWidth
          : bodyWidth - parentPadding
      var padding = ctrl.independent ? getPaddingSize() : 0
      var border = ctrl.independent ? 1 : 0
      var remainingWidth = contentWidth - padding * 2 - border
      var totalOptions = ctrl.visibleChoices.length + (ctrl.independent ? 1 : 0)
      var optionWidth = remainingWidth / totalOptions
      var maxOptionWidth = isMobile() ? 54 : 68
      return optionWidth > maxOptionWidth ? maxOptionWidth : optionWidth
    }

    function getCircularChoicesWidth() {
      var padding = ctrl.independent ? getPaddingSize() : 0
      return getOptionWidth() * ctrl.visibleChoices.length + padding
    }

    function getCircularChoiceWidth() {
      var border = 1
      var padding = getPaddingSize()
      return getOptionWidth() + padding + border
    }

    function expandImage(event, imageUrl) {
      event.preventDefault()
      event.stopPropagation()
      mediaView.showImage(imageUrl)
    }
  }
})()
